import { createAction } from 'redux-actions';
import { createCallbackActionCreator } from '@wix/da-shared-react/pkg/Stream/helpers';

interface MoveBadgePayload {
  badgeId: number;
  position: number;
  moveType: 'stream' | 'papi';
}

export const moveBadgeToPosition = createAction(
  'BADGES.MOVE_BADGE_TO_POSITION',
  (payload: MoveBadgePayload) => payload
);

export const fetchMoreBadges = createCallbackActionCreator('BADGES.FETCH_MORE');

export const refreshBadgeModules = createAction(
  'BADGES.REFRESH_MODULES',
  () => ({})
);
